import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTransactions } from 'store/transactions/useTransactions';
import { ITransferPowerForm } from 'components/onboarding/deployment/type';
import { transferPowerSchema } from 'components/onboarding/deployment/formSchema';
import { FormError } from 'components/onboarding/form/FormError';
import {
  Heading,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text
} from '@chakra-ui/react';
import { ethers } from 'ethers';

type Props = {
  powerSwitchAddress: string;
  aludelAddress: string;
  aludelAbi: ethers.ContractInterface;
};

export const TransferPowerForm: FC<Props> = ({
  powerSwitchAddress,
  aludelAddress,
  aludelAbi
}) => {
  const { transferProgramOwnership } = useTransactions();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ITransferPowerForm>({
    resolver: yupResolver(transferPowerSchema),
    mode: 'onBlur',
    defaultValues: {
      address: ''
    }
  });

  const transferPowerswitch = async ({ address }: { address: string }) => {
    await transferProgramOwnership(
      powerSwitchAddress,
      address,
      aludelAddress,
      aludelAbi
    );
  };

  return (
    <>
      <Heading size='md' mb={6}>
        Transfer Power Controller
      </Heading>
      <Text color='gray.200' mb={6}>
        This option will transfer ownership of the power controller contract
        from you to the specified wallet address. The power switch owner has the
        ability to shutdown the Aludel contract and withdraw its funds, use with
        caution.
      </Text>
      <Stack
        direction={['column', 'row']}
        alignItems={['flex-start', 'flex-end']}
        spacing={4}
      >
        <FormControl width='max-content' isRequired>
          <FormLabel>Enter Address</FormLabel>
          <Input
            id='address'
            type='text'
            borderColor={'gray.300'}
            placeholder='0x'
            {...register('address')}
          />
          {errors.address && <FormError>{errors.address.message}</FormError>}
        </FormControl>
        <Button
          px={6}
          type='submit'
          borderRadius={'lg'}
          onClick={handleSubmit((d) => transferPowerswitch(d))}
        >
          Transfer Power Controller
        </Button>
      </Stack>
    </>
  );
};
